console.log('santosh product main js running');

$(document).on("click", ".share-btn", function () {
  var productUrl = $(this).data("product-url");

  if (navigator.share) {
    navigator.share({
      title: document.title,
      text: "Check out this product!",
      url: productUrl
    });
  } else {
    navigator.clipboard.writeText(productUrl).then(() => {
      //alert("Product link copied!");
    });
  }
});


$(document).ready(function() {
  $(".addon-products").insertAfter($(".t4s-tab-wrapper.size-chart"));
});


function update_sant_size_price() {
  var urlParams = new URLSearchParams(window.location.search);
  var currentVariantId = urlParams.get("variant");

  var listItems = document.querySelectorAll(".sant-variant-price-item");
  var priceEls = document.querySelectorAll(".sant-swatch__price.not-unique");

  if (listItems.length > 0 && priceEls.length > 0) {
    var selectedColor = null;

    // First try from variant ID in URL
    if (currentVariantId) {
      var match = Array.from(listItems).find(function (li) {
        return li.dataset.variantId === currentVariantId;
      });
      if (match) {
        selectedColor = match.dataset.color;
      }
    }

    // Fallback → first variant’s color
    if (!selectedColor) {
      selectedColor = listItems[0].dataset.color;
    }

    // 🔑 Update all size prices for this color
    priceEls.forEach(function (el) {
      var size = el.dataset.size;

      var match = Array.from(listItems).find(function (li) {
        return li.dataset.color === selectedColor && li.dataset.size === size;
      });

      if (match) {
        var price = match.querySelector(".sant-variant-price").innerHTML;
        el.innerHTML = price;
      }
    });
  }
}

// Initial load
update_sant_size_price();

// On swatch click → only recalc prices
$(document).on("click", ".t4s-swatch__item", function () {
  update_sant_size_price();
});





document.addEventListener("DOMContentLoaded", function () {
  // Toggle selection
  document.querySelectorAll(".addon-product-item").forEach(item => {
    item.addEventListener("click", function () {
      this.classList.toggle("selected");
    });
  });

  // Add to cart
  document.querySelector(".addon-add-btn").addEventListener("click", function () {
    let selectedItems = [];
    document.querySelectorAll(".addon-product-item.selected").forEach(item => {
      let variantId = item.getAttribute("data-variant-id");
      selectedItems.push({
        id: variantId,
        quantity: 1
      });
    });

    if (selectedItems.length === 0) {
      alert("Please select at least one item.");
      return;
    }

    // Shopify Cart AJAX API
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: selectedItems })
    })
    .then(response => response.json())
    .then(data => {
      console.log("Added to cart:", data);
      window.location.href = "/cart"; // Redirect to cart
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    });
  });
});

